module.exports = __webpack_public_path__ + "assets/img/zbt_1.ceadccdc.png";